/**
 * @module mOffice
 * @description mOffice application procides user interface for back-office users
 */

const COMPILED_LANGUAGES = 'sk'
const PREFERRED_COUNTRIES = 'SK,CZ,AT,HU,PL,DE,CH,UA,RO,MD,BG,RS,HR,SI'
global.LOGGER_WRAPPER = 'main'

require('../mele_elements')
const { loadDevelCfgFromBridge } = require('../devel_cfg')

function beforeStart(config) {
  require('./'+MOSY_APP+'.scss')

  // Vo webovej verzii doplní dev vrstvu konfigurácie z mDevel bridge; inde vráti null
  // a `_.merge` s ním nespraví nič. Musí to byť pred `_.defaultsDeep` nižšie - ten
  // dopĺňa iba chýbajúce kľúče, takže hodnoty z bridge prežijú.
  _.merge(config, loadDevelCfgFromBridge())

  const map_center = _.CONSTANTS.Soitron
  const start_module = 'mmodOfficeWfUnits'
  const menu_modules = [
    { label: 'office.administration', disabled: true },
    'mmodOfficeWfConfigurations',
    'mmodOfficeWfApplications',
    'mmodOfficeWfEnrollments',
    'mmodOfficeWfZones',
    'mmodOfficeCertificates',
    'mmodOfficeWfBuilds',
    'mmodOfficeAdmin',
    'mmodOfficeWfUsers',
    'mmodOfficeWfDevices',
    'mmodOfficeNotifications',
    'mmodOfficeWfJobs',
    'mmodReportTrace',
    'mmodOfficeWfMapcache',
    { label: 'office.operation', disabled: true },
    'mmodOfficeWfUnits',
    'mmodOfficeWfUploads',
    'mmodOfficeWfClips',
    { label: 'office.tm', disabled: true },
    'mmodOfficeTzRecords',
    'mmodOfficeWfDelicts',
    'mmodOfficeTmDevices',
    { label: 'office.esispz', disabled: true },
    'mmodOfficeIncidents',
    'mmodOfficeInstructions',
    'mmodOfficeChats',
    'mmodOfficeAttachments',
    'mmodOfficeShapes',
    'mmodOfficeAMQ',
    { label: 'office.doppler', disabled: true },
    'mmodOfficeWfDopplers',
    'mmodOfficeWfDopplerCalibrations',
    'mmodOfficeDopplerSessions',
    'mmodOfficeInvalidationReasons',
    'mmodOfficeDopplerTransactions',
    { label: 'office.alpr', disabled: true },
    'mmodOfficeAlprsLive',
    'mmodOfficeAlprs',
    'mmodOfficeWantedVehicles',
    'mmodOfficeWantedVehiclesAgendas',
    { label: 'office.registers', disabled: true },
    'mmodOfficeWiki',
    'mmodOfficeCallsigns',
    'mmodOfficeDelictTypes',
  ]

  _.defaultsDeep(config, {
    mele_map: {
      minzoom: 8,
      center: map_center,
      maxzoom: 19,
    },
    mele_skmap: {
      minzoom: 8,
      center: map_center,
      maxzoom: 19,
    },
    msysUser: {
      users_server: ':msvrUsers',
      zones_server: ':msvrZones',
    },
    msysWM: {
      lang: 'sk',
      behavior: 'desktop',
      theme: 'day',
      styleset: 'new',
      start: start_module,
    },
    mmodAppBar: {
      modules: menu_modules,
      collapsible_groups: true,
      module_on_login: start_module,
      desktop: { type: 'dock', side: 'left', width: 200, order: 2 },
      languages: COMPILED_LANGUAGES.split(','),
      statusclick: 'logout',
    },
    mmodAppWall: {
      modules: menu_modules,
    },
    mmodEnroll: {
      auto_enroll: true,
    },
    mmodOfficeImport: {
      // TZ records take dropped files (jpeg + txt) through their own import, not the .mm parser
      forwards: ['mmodOfficeTzRecords', 'mmodOfficeTmDevices'],
    },
    mmodLogin: {
      login_format: '^[\\w-]+$',
      callsign_format: '',
    },
    msysProxy: {
      repos: {
        map_osm: { fallbacks: ['@', ':'] },
        map_topo: { fallbacks: ['@', ':'] },
        map_satellite: { fallbacks: ['@', ':'] },
        map_day: { fallbacks: ['@', ':'] },
        map_night: { fallbacks: ['@', ':'] },
        layer_roads: { fallbacks: ['@', ':'] },
        layer_railways: { fallbacks: ['@', ':'] },
        layer_hiking: { fallbacks: ['@', ':'] },
      },
    },
  })
} // beforeStart

const LISTENERS = [
  // CORE SYSTEM
  require('msysLogger'),
  require('msysExec'),

  // CORE GUI
  require('msysWM'),
  require('mmodEmpty'),
  require('mmodSplash'),
  require('mmodAppBar'),
  require('mmodAppWall'),
  require('mmodAppLogo'),
  require('mmodNotifications'),
  require('mmodOfficeImport'),

  // CLIENT/SERVER
  [require('msysLang'), 'msysLang', { prefixes: ['klady.'] }],
  require('msysProxy'),
  require('msysDomainClient'),
  require('msvcDeviceGeneric'),
  require('mmodEnroll'),
  require('msysUser'),
  require('mmodLogin'),

  // ADMINISTRATION
  require('mmodOfficeAdmin'),
  [require('mmodWorkflow'), 'mmodOfficeWfBuilds', { workflow_server: ':msvrBuilds', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfUsers', { workflow_server: ':msvrUsers', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfApplications', { workflow_server: ':msvrApplications', tabular: true }],
  [require('SK/mmodSkPatrolControl'), 'mmodSkPatrolControl'],
  [require('mmodWorkflow'), 'mmodOfficeAMQ', { workflow_server: ':msvrAmqTrace', tabular: true, list_view: 'table', filter_view: 'filter' }],
  require('mmodOfficeWfDevices'),
  [require('mmodWorkflow'), 'mmodOfficeNotifications', { workflow_server: ':msvrNotifications', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfJobs', { workflow_server: ':msvrJobs', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfUploads', { workflow_server: ':msvrUploads', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfClips', { workflow_server: ':msvrClips', tabular: true }],
  [require('mmodReport'), 'mmodReportTrace', { service: ':msvrSkTrace' }],
  [require('mmodWorkflow'), 'mmodOfficeWfMapcache', { workflow_server: ':msvrMapcache', tabular: true }],
  [require('mmod/SK/mmodSkOfficeWiki/mmodSkOfficeWiki'), 'mmodOfficeWiki', { workflow_server: ':msvrWiki' }],

  // OPERATION
  [require('mmodWorkflow'), 'mmodOfficeWfUnits', { workflow_server: ':msvrUnits', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeAlprsLive', { workflow_server: ':msvrWfAlpr', tabular: true, list_view: 'livetable', filter_view: 'livefilter' }],
  [require('mmodWorkflow'), 'mmodOfficeAlprs', { workflow_server: ':msvrWfAlpr', tabular: true }],
  require('SK/msvcSkGIS'),
  require('mmodOfficeWfDelicts'),
  require('mmodOfficeWfDopplers'),
  require('mmodOfficeWfDopplerCalibrations'),
  [require('mmodWorkflow'), 'mmodOfficeDelictTypes', { workflow_server: ':msvrWfDelictTypes', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeInvalidationReasons', { workflow_server: ':msvrSkWfInvalidationReasons', tabular: true }],
  [require('SK/mmodOfficeWfTmDevices'), 'mmodOfficeTmDevices', { workflow_server: ':msvrSkWfTmDevices', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeDopplerSessions', { workflow_server: ':msvrSkWfDopplerSessions', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeDopplerTransactions', { workflow_server: ':msvrSkWfDopplerTransactions', tabular: true }],
  [require('mmodOfficeWfTzRecords'), 'mmodOfficeTzRecords'],

  // REGISTERS
  [require('mmodWorkflow'), 'mmodOfficeCallsigns', { workflow_server: ':msvrWfCallsigns', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeCertificates', { workflow_server: ':msvrWfCertificates', tabular: true }],

  // MASTER
  require('mmodOfficeWfConfigurations'),
  [require('mmodWorkflow'), 'mmodOfficeWfEnrollments', { workflow_server: ':msvrEnrollments', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfZones', { workflow_server: ':msvrZones', tabular: true }],

  // INTEGRATIONS
  [require('mmodWorkflow'), 'mmodOfficeAttachments', { workflow_server: ':msvrAttachments', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeChats', { workflow_server: ':msvrChats', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeIncidents', { workflow_server: ':msvrIncidents', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeInstructions', { workflow_server: ':msvrInstructions', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeShapes', { workflow_server: ':msvrShapes', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWantedVehiclesAgendas', { workflow_server: ':msvrWfWantedVehiclesAgendas', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWantedVehicles', { workflow_server: ':msvrWfWantedVehicles', tabular: true }],
] // LISTENERS

require('msysApplication')(LISTENERS, beforeStart)
